import { ColumnDef } from "@tanstack/react-table"
import { OptionsColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import { SelectOption } from "../../../../../types"

export default (columnDefinition: OptionsColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const value = info.getValue() as string
        const defaultValue = columnDefinition.dataAttributes?.defaultValue || "-"
        const options = (info.table.options.meta?.additionalOptions ?? {})[columnDefinition.dataAttributes.optionsKey] ?? [] as SelectOption<string>[]

        if (value && options) {
            const option = options.find(option => option.value === value)
            return option ? option.label : defaultValue
        } else {
            return defaultValue
        }
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/OptionsCellMapper.tsx